module.exports = __webpack_public_path__ + "static/media/TCI.Terms.of.Use.6942e5e6.docx";